import Router from './routes';
import ThemeProvider from './theme';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import { Helmet } from 'react-helmet-async';
import { StyledChart } from './components/chart';
import { AutoLogoutProvider } from './components/AutoLogoutProvider';
import { useEffect } from 'react';
import { appEnvVariables, googleAnalytics, clarity } from './config';
import ReactGA from 'react-ga4';
import { Environment } from './@types/types';
import './style.css';
import Clarity from '@microsoft/clarity';

const { measurementId } = googleAnalytics;

const claritySiteId = clarity.siteId;
const isProduction = appEnvVariables.environment === Environment.PRODUCTION;

export default function App() {
  useEffect(() => {
    if (isProduction) {
      ReactGA.initialize(measurementId);

      Clarity.init(claritySiteId);
    }
  }, []);

  return (
    <>
      <Helmet>
        <script type="text/javascript" src={`/js/new_relic_${appEnvVariables.environment}.js`} />
        <meta name="robots" content={isProduction ? 'index, follow' : 'noindex, nofollow'} />
      </Helmet>
      <MotionLazyContainer>
        <ThemeProvider>
          <AutoLogoutProvider>
            <ProgressBarStyle />
            <ScrollToTop />
            <StyledChart />
            <Router />
          </AutoLogoutProvider>
        </ThemeProvider>
      </MotionLazyContainer>
    </>
  );
}
